/**
 * Struttura attesa dal componente `Quiz`:
 * {
 *   id: string,
 *   videoId: string | null,
 *   title: string,
 *   questions: Array<{
 *     id: string,
 *     text: string,
 *     choices: Array<{ id: string, text: string }>,
 *     correctChoiceIds: string[],
 *     multiSelect: boolean,
 *   }>
 * }
 *
 * Utilizzo rapido:
 * const quiz = createQuizTemplate({ id: "quiz-xyz", videoId: "video-123", title: "Quiz XYZ" })
 * const q2 = createQuestion({ id: "quiz-xyz-q2", text: "Seconda domanda", choices: [{id:"a",text:"A"},{id:"b",text:"B"}], correctChoiceIds:["b"] })
 * const finalQuiz = addQuestion(quiz, q2)
 */
export function createQuizTemplate({ id = "quiz-id", videoId = null, title = "Nuovo Quiz" } = {}) {
  return {
    id,
    videoId,
    title,
    questions: [],
  }
}

/**
 * Crea una nuova domanda.
 * - id: identificativo univoco della domanda (es. "quiz-xyz-q2")
 * - text: testo della domanda
 * - choices: array di scelte { id, text }
 * - correctChoiceIds: array di id delle risposte corrette
 * - multiSelect: abilita selezione multipla
 */
export function createQuestion({ id, text = "", choices = [], correctChoiceIds = [], multiSelect = false } = {}) {
  const baseChoices = choices.length ? choices : [
    { id: "a", text: "" },
    { id: "b", text: "" },
    { id: "c", text: "" },
  ]
  const baseCorrect = correctChoiceIds.length ? correctChoiceIds : ["a"]
  return { id, text, choices: baseChoices, correctChoiceIds: baseCorrect, multiSelect }
}

/**
 * Aggiunge una domanda a un quiz esistente.
 */
export function addQuestion(quiz, question) {
  return { ...quiz, questions: [...quiz.questions, question] }
}

/*
 * Esempio completo:
 * const quiz = createQuizTemplate({ id: "quiz-sample", videoId: "video-001", title: "Quiz di esempio" })
 * const domandaMulti = createQuestion({
 *   id: "quiz-sample-q2",
 *   text: "Seleziona tutte le risposte corrette",
 *   choices: [
 *     { id: "a", text: "Opzione A" },
 *     { id: "b", text: "Opzione B" },
 *     { id: "c", text: "Opzione C" },
 *   ],
 *   correctChoiceIds: ["a", "c"],
 *   multiSelect: true,
 * })
 * const quizComposto = addQuestion(quiz, domandaMulti)
 */
export const sampleQuiz = createQuizTemplate({ id: "quiz-sample", title: "Quiz di esempio", videoId: "video-sample" })
